// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQ_root__TTcPD","question":"FAQ_question__3Wlkp","icon":"FAQ_icon__1u8C8","answers":"FAQ_answers__EjCLR"};